import React from "react";

type FieldProps = {
  label: string;
  children: React.ReactNode;
  error?: string;
  helper?: string;
};

export default function Field({ label, children, error, helper }: FieldProps) {
  return (
    <div className="space-y-2">
      {/* LABEL */}
      <label className="block text-[9px] uppercase tracking-[0.5em] text-black/40">
        {label}
      </label>

      {/* INPUT WRAP
          ✅ Không border-b + không py-2 nữa để tránh double line/double spacing
          ✅ ring rất nhẹ cho luxury
      */}
      <div
        className={`
          rounded-md transition
          ${error ? "ring-1 ring-red-500/25" : "ring-1 ring-black/0"}
          focus-within:ring-black/10
        `}
      >
        {/* auto add lux-error nếu input có class lux-input */}
        <div className={`${error ? "[&_.lux-input]:lux-error" : ""}`}>
          {children}
        </div>
      </div>

      {/* HELPER / ERROR */}
      {(error || helper) && (
        <p
          className={`
            text-[9px] uppercase tracking-[0.35em]
            ${error ? "text-red-500/70" : "text-black/30"}
          `}
        >
          {error || helper}
        </p>
      )}
    </div>
  );
}
